import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Card from "../../../components/Card";
import { getApiCall } from "../../../service/httpCall";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Loader from "../../../components/partials/components/loader";
import { Dropdown } from "primereact/dropdown";
import {
  FaPlus,
  FaMinus,
  FaExchangeAlt,
  FaMicrophone,
  FaArrowUp,
  FaArrowDown
} from "react-icons/fa";
import {
  API_COMPANY_LIST,
  API_CREDIT_HISTORY_SUMMARY_OF_SPECIFIC_COMPANY,
} from "../../../service/url";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

const COLORS = [
  "#28a745",
  "#dc3545",
  "#20c997",
  "#fd7e14",
  "#007bff",
  "#6f42c1",
];

const dateToInputStr = (d) => {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const inputStrToLocalDate = (str) => {
  if (!str) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
  if (!m) {
    const d = new Date(str);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
};

const SummaryPage = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [records, setRecords] = useState([]);
  const [summary, setSummary] = useState({
    addition: 0,
    deduction: 0,
    tts_addition: 0,
    tts_deduction: 0,
    inbound_deduction: 0,
    outbound_deduction: 0,
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [loading, setLoading] = useState(false);

  const summaryConfig = [
    {
      key: "addition",
      label: "Voice Addition",
      icon: <FaPlus />,
      color: "#28a745",
    },
    {
      key: "deduction",
      label: "Voice Deduction",
      icon: <FaMinus />,
      color: "#dc3545",
    },
    {
      key: "tts_addition",
      label: "TTS Addition",
      icon: <FaMicrophone />,
      color: "#20c997",
    },
    {
      key: "tts_deduction",
      label: "TTS Deduction",
      icon: <FaMicrophone />,
      color: "#fd7e14",
    },
    {
      key: "inbound_deduction",
      label: "Inbound Deduction",
      icon: <FaExchangeAlt />,
      color: "#007bff",
    },
    {
      key: "outbound_deduction",
      label: "Outbound Deduction",
      icon: <FaExchangeAlt />,
      color: "#6f42c1",
    },
  ];

  const fetchCompanies = async () => {
    const resp = await getApiCall(API_COMPANY_LIST);
    setCompanies(resp || []);
  };

  const fetchSummary = async () => {
    if (!selectedCompany) return;

    setLoading(true);

    const start = formatDate(startDate);
    const end = formatDate(endDate);

    const url = `${API_CREDIT_HISTORY_SUMMARY_OF_SPECIFIC_COMPANY}/${selectedCompany}?startDate=${start}&endDate=${end}`;

    const resp = await getApiCall(url);

    setRecords(resp.records || []);
    setSummary(resp.summary || {});

    setLoading(false);
  };

  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    setStartDate(firstDay);
    setEndDate(today);

    fetchCompanies();
  }, []);

  const formatDate = (date) => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
  };

  const handleFilter = () => {
    fetchSummary();
  };

const handleClear = async () => {
    setLoading(true);

    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    setSelectedCompany(null);
    setStartDate(firstDay);
    setEndDate(today);
    setRecords([]);
    setSummary({
        addition: 0,
        deduction: 0,
        tts_addition: 0,
        tts_deduction: 0,
        inbound_deduction: 0,
        outbound_deduction: 0,
    });

    await fetchCompanies(); 

    setLoading(false); 
};

  const chartData = summary
    ? [
        { name: "Voice Add", value: summary.addition },
        { name: "Voice Deduct", value: summary.deduction },
        { name: "TTS Add", value: summary.tts_addition },
        { name: "TTS Deduct", value: summary.tts_deduction },
        { name: "Inbound", value: summary.inbound_deduction },
        { name: "Outbound", value: summary.outbound_deduction },
      ]
    : [];

  if (loading) return <Loader />;

  return (
    <Row>
      <Col sm="12">
        <Card>
          <Card.Header>
            <h4>Credit Summary</h4>
          </Card.Header>

          <Card.Body>
            <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
              <Form.Select
  value={selectedCompany || ""}
  onChange={(e) =>
    setSelectedCompany(e.target.value || null)
  }
  style={{ width: "220px" }}
>
  <option value="">Select Company</option>

  {companies.map((company) => (
    <option
      key={company.id}
      value={company.id}
    >
      {company.name}
    </option>
  ))}
</Form.Select>

              <Form.Control
                type="date"
                value={dateToInputStr(startDate)}
                onChange={(e) => setStartDate(inputStrToLocalDate(e.target.value))}
                style={{ width: "170px", flexShrink: 0 }}
              />
              <Form.Control
                type="date"
                value={dateToInputStr(endDate)}
                onChange={(e) => setEndDate(inputStrToLocalDate(e.target.value))}
                style={{ width: "170px", flexShrink: 0 }}
              />

              <Button
               label="Filter" onClick={handleFilter} />
              <Button 
              label="Refresh" 
              icon="pi pi-refresh"
              className="p-button-primary" 
              onClick={handleClear} 
              style={{ height: "45px", width: "100px" }} 
    />
            </div>

            {summaryConfig && (
              <div className="row mb-4">
                {summaryConfig.map((item, index) => (
                  <div className="col-md-4 mb-3" key={index}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        padding: "18px",
                        borderRadius: "14px",
                        background: "#fff",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                        borderLeft: `5px solid ${item.color}`,
                      }}
                    >
                      <div style={{ fontSize: "20px", color: item.color }}>
                        {item.icon}
                      </div>

                      <div>
                        <p
                          style={{ margin: 0, fontSize: "13px", color: "#777" }}
                        >
                          {item.label}
                        </p>

                        <h5 style={{ margin: 0, fontWeight: "600" }}>
                          ₹{summary?.[item.key] || 0}
                        </h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {selectedCompany &&
              summary &&
              Object.values(summary).some((val) => Number(val) > 0) && (
                <div className="row" style={{ marginBottom: "30px" }}>
                  <div className="col-md-6">
                    <BarChart width={500} height={300} data={chartData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                      <XAxis dataKey="name" stroke="#ccc" />
                      <YAxis stroke="#ccc" />
                      <Tooltip />

                      <Bar dataKey="value">
                        {chartData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Bar>
                    </BarChart>
                  </div>

                  <div className="col-md-6">
                    <PieChart width={400} height={300}>
                      <Pie
                        data={chartData}
                        dataKey="value"
                        nameKey="name"
                        outerRadius={100}
                        label
                      >
                        {chartData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>

                      <Legend />
                      <Tooltip />
                    </PieChart>
                  </div>
                </div>
              )}

            <DataTable value={records} paginator rows={10}>
              <Column
                header="Action"
                  body={(rowData) => {
    const action = rowData.action;

    const actionMap = {
      addition: {
        label: "Voice Addition",
        icon: <FaArrowUp color="green" style={{ marginRight: "8px" }} />,
      },
      deduction: {
        label: "Voice Deduction",
        icon: <FaArrowDown color="red" style={{ marginRight: "8px" }} />,
      },
      tts_addition: {
        label: "TTS Addition",
        icon: <FaArrowUp color="green" style={{ marginRight: "8px" }} />,
      },
      tts_deduction: {
        label: "TTS Deduction",
        icon: <FaArrowDown color="red" style={{ marginRight: "8px" }} />,
      },
      inbound_deduction: {
        label: "Inbound Deduction",
        icon: <FaArrowDown color="red" style={{ marginRight: "8px" }} />,
      },
      outbound_deduction: {
        label: "Outbound Deduction",
        icon: <FaArrowDown color="red" style={{ marginRight: "8px" }} />,
      },
    };

    const data = actionMap[action];

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {data?.icon}
        {data?.label || action}
      </div>
    );
                }}
              />
              <Column field="credits_rupees" header="Amount" />
              <Column field="balance" header="Balance" />
              <Column
                field="created_at"
                header="Date"
                body={(row) => new Date(row.created_at).toLocaleString()}
              />
            </DataTable>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SummaryPage;
